<template>
  <div class="ds-error-state">
    <i class="ds-error-state__icon el-icon-warning-outline"></i>
    <div class="ds-error-state__title">{{ title || $t('common.operationFailed') }}</div>
    <div class="ds-error-state__desc" v-if="description">{{ description }}</div>
    <div class="ds-error-state__code" v-if="code">错误码：{{ code }}</div>
    <div class="ds-error-state__action" v-if="showRetry || $slots.action">
      <slot name="action">
        <el-button v-if="showRetry" type="primary" size="small" icon="el-icon-refresh"
          @click="$emit('retry')">
          重试
        </el-button>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * DsErrorState —— 错误态
 *
 * 现状问题：大量页面 catch 中只有 console.error，用户完全无感知；
 * 本组件提供「用户可见的错误提示 + 重试入口」。
 *
 * Props:
 *  - title       {String} 标题
 *  - description {String} 描述
 *  - code        {String|Number} 错误码
 *  - showRetry   {Boolean} 是否显示重试按钮
 *
 * Events:
 *  - retry  点击重试
 */
export default {
  name: 'DsErrorState',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    code: {
      type: [String, Number],
      default: ''
    },
    showRetry: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--ds-spacing-2xl) var(--ds-spacing-lg);
  text-align: center;

  &__icon {
    font-size: 40px;
    color: var(--ds-danger);
    margin-bottom: var(--ds-spacing-md);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
    line-height: 1.5;
  }

  &__desc {
    margin-top: var(--ds-spacing-xs);
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
    max-width: 460px;
    line-height: 1.6;
  }

  &__code {
    margin-top: var(--ds-spacing-xs);
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-400);
    font-family: var(--ds-font-family-num);
  }

  &__action {
    margin-top: var(--ds-spacing-md);
  }
}
</style>
